import { type PropType, computed } from 'vue';
import { type ComponentSizes, componentDefaultSize } from '../../constants';

export interface ListProps {
    size?: ComponentSizes,
    columns?: number,
    title?: string,
    space?: number[],
}

export const listProps = {
    size: {
        type: String as PropType<ListProps['size']>,
        default: componentDefaultSize,
        required: false,
    },
    columns: {
        type: Number as PropType<ListProps['columns']>,
        default: undefined,
        required: false,
    },
    title: {
        type: String as PropType<ListProps['title']>,
        default: undefined,
        required: false,
    },
    space: {
        type: Array as PropType<ListProps['space']>,
        default: undefined,
        required: false,
    },
};

export interface ListItemProps {
    label?: string,
    space?: number[],
    labelWidth?: string,
    valueWidth?: string,
}

export const listItemProps = {
    label: {
        type: String as PropType<ListItemProps['label']>,
        default: undefined,
        required: false,
    },
    space: {
        type: Array as PropType<ListItemProps['space']>,
        default: undefined,
        required: false,
    },
    labelWidth: {
        type: String as PropType<ListItemProps['labelWidth']>,
        default: undefined,
        required: false,
    },
    valueWidth: {
        type: String as PropType<ListItemProps['valueWidth']>,
        default: undefined,
        required: false,
    },
};
